import Vue from 'vue'
import Moment from 'moment'
import {
  stringHidden,
  isEmpty,
  fmAuditColor,
  fmOrderColor,
} from '@/utils/stringUtil.js'
import { getRelativeTime } from '@/utils/tool.js'

// 定义全局时间戳过滤器
Vue.filter('formatRelativeTime', (value) => (isEmpty(value) || value === 0 ? '--' : getRelativeTime(value)))

Vue.filter('formatDate', (value) => (isEmpty(value) || value === 0 ? '--' : Moment(value * 1000).format('YYYY-MM-DD HH:mm')))

Vue.filter('formatMonthDayTime', (value) => (isEmpty(value) || value === 0 ? '--' : Moment(value * 1000).format('MM-DD HH:mm')))

Vue.filter('formatDateTime', (value) => (isEmpty(value) || value === 0 ? '--' : Moment(value * 1000).format('YYYY-MM-DD HH:mm:ss')))

Vue.filter('formatTime', (value) => (isEmpty(value) || value === 0 ? '--' : Moment(value * 1000).format('HH:mm:ss')))

Vue.filter('formatMonth', (value) => (isEmpty(value) || value === 0 ? '--' : Moment(value * 1000).format('YYYY-MM')))

Vue.filter('formatDay', (value) => (isEmpty(value) || value === 0 ? '--' : Moment(value * 1000).format('YYYY-MM-DD')))

Vue.filter('formatPlateNumber', (value) => stringHidden(value, 2, 1))

Vue.filter('formatReportName', (value) => stringHidden(value, 1, 0))

Vue.filter('formatRateColor', (val) => {
  if (val > 0 && val <= 20) {
    return 'deep-orange'
  } else if (val > 20 && val <= 40) {
    return 'orange darken-4'
  } else if (val > 40 && val <= 60) {
    return 'orange'
  } else if (val > 60 && val <= 80) {
    return 'teal'
  } else if (val > 80 && val <= 90) {
    return 'light-green darken-4'
  } else if (val > 90) {
    return 'green'
  }
  return 'grey'
})

Vue.filter('formatPrice', (value) => {
  if (value >= 10000 && value < 10000000) {
    value = `${value / 10000}万`
  } else if (value >= 10000000) {
      value = `${value / 10000000}千万`
  }
  return value
})
Vue.filter('formatObjectToArray', (value) => {
  const arr = []
  if (!isEmpty(value)) {
    arr.push(value)
  }
  return arr
})

Vue.filter('formatObjectId', (value) => {
  const obj = {}
  if (!isEmpty(value)) {
    obj.id = value
  }
  return obj
})

Vue.filter('formatHeadType', (value) => (value === 1 ? "个人" : "企业"))

Vue.filter('formatPatentType', (value) => (value === 1 ? "实用新型" : value === 2 ? "发明专利" : "外观专利"))

Vue.filter('formatReduction', (value) => (value === 0 ? "未知" : value === 1 ? "已费减" : "不需要"))

Vue.filter('formatAnnualFeeStatus', (value) => (value === 0 ? "已放弃" : value === 1 ? "已缴纳" : "未缴纳"))

Vue.filter('formatDataFrom', (value) => (value === 1 ? "PC端" : value === 2 ? "微信端" : "小程序"))

Vue.filter('formatAuditStatus', (value) => (value === 0 ? "审核中" : value === 0-1 ? "未通过" : value === 1 ? "已通过" :  "未知"))

Vue.filter('formatAuditColor', (value) => fmAuditColor(value))

Vue.filter('formatOrderColor', (value) => fmOrderColor(value))

Moment.locale('zh-cn'); // 设置语言 或 moment.lang('zh-cn');
Vue.prototype.$moment = Moment
